import {UI} from "../../../../../../stem-core/ui/UIBase";
import {StyleSheet} from "../../../../../../stem-core/ui/Style";
import {Messages} from "../../../../../Messages";
import {styleRule} from "../../../../../../stem-core/decorators/Style";
import {registerStyle} from "../../../../../../stem-core/ui/style/Theme";
import {CheckboxInput} from "../../../../../../stem-core/ui/input/checkbox/CheckboxInput.jsx";
import {NOOP_FUNCTION} from "../../../../../../stem-core/base/Utils";
import {CardForm} from "./CardForm.jsx";
import {PaymentMethod} from "../../../../../../client/state/PaymentMethodStore.js";
import {Flow} from "../../../../flows/Flow.js";


class AddPaymentMethodComponentStyle extends StyleSheet {
    @styleRule
    saveCardCheckbox = {
        marginTop: 12,
        fontSize: this.themeProps.FONT_SIZE_NORMAL + " !important",
        color: this.themeProps.TEXT_SECONDARY_COLOR + " !important",
    };
}


@registerStyle(AddPaymentMethodComponentStyle)
export class AddPaymentMethodComponent extends UI.Element {
    getDefaultOptions() {
        return {
            onChange: NOOP_FUNCTION,
            testId: "payWithAddedCard",
        };
    }

    render() {
        const {styleSheet} = this;

        const shouldAskToStorePaymentMethod = Flow.paymentMethod.showSaveCardCheckbox;

        return [
            <CardForm ref="cardForm" onChange={this.options.onChange}/>,

            shouldAskToStorePaymentMethod && <CheckboxInput
                ref="storeCardCheckbox"
                testId="storeCardCheckbox"
                className={styleSheet.saveCardCheckbox}
                initialValue={Flow.paymentMethod.savePaymentMethod}
                label={Messages.saveCardDetailsCheckbox}
                onChange={enabled => Flow.paymentMethod.update({savePaymentMethod: enabled})}
            />
        ];
    }

    isValid() {
        return this.cardForm.isValid();
    }

    async getPaymentMethod() {
        let scope = Flow.paymentMethod.scope;
        if (this.storeCardCheckbox?.getValue()) {
            scope = PaymentMethod.Scope.PUBLIC;
        }

        return this.cardForm.confirmCard(scope);
    }
}
